import { default as Component, getComponent } from "@/models/Component.js";

export const Default = {
    data: () => ({
        component: undefined
    }),
    props: {
        param: Object,
        params: Array,
        sourceType: String,
        featureName: String,
        componentName: String,
        source: String
    },
    methods: {
        _getMeasParams() {
            switch (this.source) {
            case "plant":
                return { plant: this.param.id, source: "plant" };
            case "equipment":
                return { equipment: this.param.id, source: "equipment" };
            case "plants":
                return { plants: this.params, source: "plant" };
            case "equipments":
                return { equipments: this.params, source: "equipment" };
            default:
                throw new Error(
                    "Source prop are not properly defined, check for param or params prop too."
                );
            }
        },
        async _fetchComponent(params) {
            params = {
                feature_name: this.featureName,
                name: this.componentName
            };
            this.component = await getComponent(params);
        },
        _checkComponent() {
            if (!this.component) return false;
            // if (!this.component.name || this.component.name.trim() == "") return false;
            return true;
        },
        async _fetchRealtime(params) {
            params = params ? params : this._getMeasParams();
            if (this._checkComponent()) {
                await this.component.setRealtime(params);
                return this.component.realtimeMeasures;
            }
            return [];
        },
        async _fetchConstant(params) {
            params = params ? params : this._getMeasParams();
            if (this._checkComponent()) {
                await this.component.setConstant(params);
                return this.component.constantMeasures;
            }
            return [];
        },
        async _fetchHistorical(params) {
            params = params ? params : this._getMeasParams();
            if (this._checkComponent()) {
                await this.component.setHistorical(params);
                return this.component.historicalMeasures;
            }
            return [];
        },
        async _fetchAlarms(params) {
            params = params ? params : this._getMeasParams();
            if (this._checkComponent()) {
                await this.component.setHistorical(params);
                return this.component.alarms;
            }
            return [];
        },
        async _fetchSpecific() {
            if (this._checkComponent()) {
                await this.component.setSpecific();
                return this.component.specificMeasures;
            }
            return [];
        },
        _connectMQTT() {
            if (this._checkComponent()) this.component.connectMQTT();
        },
        _subscribe() {
            if (this._checkComponent()) this.component.subscribe();
        },
        _unsubscribe() {
            if (this._checkComponent()) this.component.unsubscribe();
        }
    },
    beforeDestroy() {
        if (this._checkComponent() && this.component.realtimeMeasures && this.component.realtimeMeasures.length) {
            this.component.unsubscribe();
        }
    }
};
